import { CSSProperties } from 'react'

import styled from '@emotion/styled'

import { spacing } from '../../theme'

type Spacing = keyof typeof spacing

const GridCommon = styled.div<{
  gridAutoColumns?: CSSProperties['gridAutoColumns']
  gridAutoFlow?: CSSProperties['gridAutoFlow']
  gridTemplateColumns?: CSSProperties['gridTemplateColumns']
  rowGap?: Spacing
  columnGap?: Spacing
  gap?: Spacing
}>`
  ${({ gridAutoColumns }) => gridAutoColumns && `grid-auto-columns: ${gridAutoColumns};`}
  ${({ gridAutoFlow }) => gridAutoFlow && `grid-auto-flow: ${gridAutoFlow};`}
  ${({ gridTemplateColumns }) => gridTemplateColumns && `grid-template-columns: ${gridTemplateColumns};`}
  ${({ rowGap }) => rowGap && `row-gap: ${spacing[rowGap]};`}
  ${({ columnGap }) => columnGap && `column-gap: ${spacing[columnGap]};`}
  ${({ gap }) => gap && `gap: ${spacing[gap]};`}
`

export const Grid = styled(GridCommon)`
  display: grid;
`

export const InlineGrid = styled(GridCommon)`
  display: inline-grid;
`
